module.exports = __webpack_public_path__ + "static/media/profile.9c02d7cf.png";